import { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import {
  RespCode,
  ErrorCode,
  env,
  ClaimType,
  TOTAL_MONEY_LIMIT_FOR_CHECKED,
  ClaimTypeText, regEmail, ErrorCodeToSpecialText,
} from '@constants';
import { submitClaim, reportEvent, getReviewQuote } from '@api';
import { logError } from '@log';
import { useReviewData, useEffectOnce } from '@hooks';
import { clearSelectedItems, setClaimList } from '@store/slices';

export const useReview = () => {
  const [isConfirmed, setIsConfirmed] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [quotePrice, setQuotePrice] = useState('0.00 USD');
  const {
    files, comments,
    // files1,
    type,
    orderName, selectedData, selectedPackageList, paymentMethod, totalMoneyValue, returnMethod, reviewData, selectedDhgateItems, dhgateFulfillments, delayPackageId, dhgateItems,
  } = useSelector((state) => state.claim);
  const {
    reasonList, platform, email, behaviorData, signature, orderNumber,
  } = useSelector((state) => state.policy);
  const [customEmail, setCustomEmail] = useState(email);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { getReviewData } = useReviewData();
  const [bpChecked, setBPChecked] = useState(totalMoneyValue > TOTAL_MONEY_LIMIT_FOR_CHECKED);
  // console.log(useSelector((state) => state));

  const getReviewItemData = () => {
    const track = { ...dhgateFulfillments.find((v) => v.fulfillmentId === delayPackageId) || {} };
    const items = dhgateItems.filter((v) => Object.keys(selectedDhgateItems).includes(v.lineItemId)) || [];

    // const trackInfo = [];
    // trackInfo.push(items.map((item) => {
    //   const info = Object.values(selectedDhgateItems).find((_) => _.lineItemId === item.lineItemId) || {};

    //   return {
    //     ...track, claimQuantity: info.quantity, ...info, items: [item],
    //   };
    // }).flat());
    // return {
    //   issueTypeDesc: ClaimTypeText[type], attachments: files, comment: comments, items: [...trackInfo].flat(),
    // };

    const trackInfo = {
      issueTypeDesc: ClaimTypeText[type], attachments: files, comment: comments,
    };

    trackInfo.items = items.map((item) => {
      const info = Object.values(selectedDhgateItems).find((_) => _.lineItemId === item.lineItemId) || {};
      return {
        ...track,
        items: [{
          ...item,
          quantity: info.quantity,
        }],
        attachments: info.attachments,
        comment: info.comment,
      };
    });
    if (type === ClaimType.Delay) {
      trackInfo.items = [track];
    }
    // console.log(trackInfo, 'trackInfo');
    return trackInfo;
  };

  const trackInfo = getReviewItemData();
  // const selected = Object.values(selectedDhgateItems).filter(v=>{
  //   let ful = dhgateFulfillments.find()
  // });
  // for(let key in selectedDhgateItems){
  //   let ful = dhgateFulfillments.find(v=>v.fulfillmentId===key)
  // }
  const handleChange = (event) => {
    setIsConfirmed(event.target.checked);
  };

  const handleEmailChange = (e) => {
    const val = e.target.value;
    if (regEmail.test(val)) {
      setCustomEmail(val);
    } else {
      setCustomEmail('');
    }
  };

  const onClickContinue = async () => {
    const url = env === 'prod' ? 'https://api.seel.com/gateway/tracking-service/api/tracking-event' : 'https://api-dev.seel.com/gateway/tracking-service/api/tracking-event';

    try {
      setIsLoading(true);

      const resp = await submitClaim({
        ...selectedData, applicantEmail: customEmail, path: '/gateway/claim-service/api/resolution-center/dhgate/', headers: { signature, 'order-id': orderNumber },
      });
      const reportData = {
        ...behaviorData,
        submitTime: Date.now(),
      };

      setIsLoading(false);
      const { code, data, message } = resp;
      if (code !== RespCode.Success) {
        // 失败上报
        reportData.isSuccess = false;
        reportData.failureReason = message || code;
        reportEvent('Claim submission failed', { reportData, url, platform });
        if (ErrorCodeToSpecialText.includes(code)) {
          navigate('../error', { state: { code } });
        } else {
          navigate('../error', { state: { code: ErrorCode.Wrong } });
        }
        return;
      }
      // 成功上报
      reportData.isSuccess = true;
      reportEvent('Claim submission succeed', { reportData, url, platform });
      dispatch(setClaimList({ claimId: data.claimId, status: 'In Progress' }));
      dispatch(clearSelectedItems());
      navigate(`../feedback?claimId=${data.claimId}`);
    } catch (error) {
      logError(error);
    }
  };

  const handleWidgetChange = async (value) => {
    const isSuccess = await getReviewData({ useShippingLabel: returnMethod.value === '1', includeBp: value });
    if (isSuccess) {
      setBPChecked(value);
    }
  };
  useEffectOnce(async () => {
    if (type === ClaimType.RA) {
      const { premium: { presentation } = {} } = await getReviewQuote({
        ...selectedData,
        includeBp: true,
      });
      setQuotePrice(presentation);
    }
  });
  return {
    files,
    // files1,
    comments,
    platform,
    orderName,
    type,
    reviewData: { ...reviewData, ...paymentMethod, shippingOnOwn: returnMethod.value === '2' },
    reasonList,
    selectedPackageList,
    isConfirmed,
    isLoading,
    customEmail,
    bpChecked,
    quotePrice,
    trackInfo,
    selectedDhgateItems,
    handleWidgetChange,
    onClickContinue,
    handleChange,
    handleEmailChange,
  };
};
